module.exports = __webpack_public_path__ + "img/green-icon(1).2650e20c.png";